/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * AUTO-GENERATED API METHODS - DO NOT EDIT
 * Generated from: MerchantProfileContract
 */

import { apiClient } from '../../utils/api-client';
import type {
  GetMerchantProfileParamsType,
  GetMerchantProfileResponseType,
  MessageResponse,
  UpdateMerchantProfileBodyType,
  UpdateMerchantProfileParamsType,
} from '@zlinkx/shared-v2';

export const merchantprofileApi = {
  getMerchantProfile: async (
    merchantId: GetMerchantProfileParamsType['merchantId']
  ): Promise<GetMerchantProfileResponseType> => {
    return apiClient.get<GetMerchantProfileResponseType['data']>(`/merchants/${merchantId}`) as Promise<GetMerchantProfileResponseType>;
  },

  updateMerchantProfile: async (
    merchantId: UpdateMerchantProfileParamsType['merchantId'],
    data: UpdateMerchantProfileBodyType
  ): Promise<MessageResponse> => {
    return apiClient.patch(`/merchants/${merchantId}`, data);
  },
};